import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IoCloseSharp } from "react-icons/io5";
import { FaArrowDownWideShort } from "react-icons/fa6";
import { Timestamp } from 'firebase/firestore';
import { formatNumber, formatNumbers, formatTimestamp, formatWithSign, getBetPrimaryName, getLiveLabel, getPendingMarketSubLabel, isFreePlayBet, isPropsBet } from '../../../helpers/functions.tsx';
import { BetDetails, Player } from '../../../models/MyBetModel.tsx';
import { BetDetailsBox } from './BetDetailsBox.tsx';
import { FaSyncAlt } from 'react-icons/fa';
import { buildVisitedUserNavState } from '../../../helpers/adminVisitedUserCache.tsx';
import { Users } from '../../../models/User.tsx';
import BetLogo from '../../player/modals/BetLogo.tsx';

const playerNavState = (player?: Player) =>
    buildVisitedUserNavState({
        id: player?.userDocId,
        userName: player?.userName,
        pin: player?.pin,
        parent: player?.parent,
    } as Users);

const BodyPending = ({ customer, playerResult, filters, sortPlayers, isLoading, hasSearched, setSelectedBet, currentUser }) => {

    const [expandedPlayers, setExpandedPlayers] = useState(new Set());

    const togglePlayerDetails = (bet: any) => {
        const newExpandedPlayers = new Set(expandedPlayers);
        if (newExpandedPlayers.has(bet.ticket)) {
            newExpandedPlayers.delete(bet.ticket);
        } else {
            newExpandedPlayers.add(bet.ticket);
        }
        setExpandedPlayers(newExpandedPlayers);
    };

    const playersToDisplay = hasSearched ? playerResult : customer;
    const sortedPlayers = sortPlayers(playersToDisplay);

    return (
        <>
            {isLoading ? (
                <div className="text-center p-4">
                    <FaSyncAlt className="loader-icon-proyect" />
                    <div className="mt-2">Loading results...</div>
                </div>
            ) : hasSearched && playersToDisplay.length === 0 ? (
                <div className="text-center p-2 body-customer fw-bold" style={{ color: "#ffffffff", background: "#082141ff" }}>
                    No data found
                </div>
            ) : (
                <table className="table table-custom">
                    <thead className='header-customer'>
                        <tr>
                            {filters?.agentID && <th className='none' >Agent</th>}
                            <th className='customer-show '>
                                <div className="th-flex">
                                    <span>Customer</span>
                                    <button className='button-sort no-show' data-bs-toggle="modal" data-bs-target="#sort">
                                        <FaArrowDownWideShort /> Sort
                                    </button>
                                </div>
                            </th>
                            {filters?.password && <th className='none'>Password</th>}
                            {filters?.timeScheduled && <th className='none estilo customer'>Scheduled (PST)</th>}
                            {filters?.timeAccepted && <th className='none estilo customer'>Accepted (PST)</th>}
                            <th className='none'>Description</th>
                            <th className='none table-pending-risk'>Risk</th>
                            <th className='none  table-pending-risk'>To Win</th>
                            <th className='none'></th>
                        </tr>
                    </thead>
                    <tbody className='body-customer'>
                        {sortedPlayers.map((bet: BetDetails) => {
                            const liveLabel = getLiveLabel(bet.gameType);

                            return (
                                <React.Fragment key={bet.ticket}>
                                    <tr className="hover-row" onClick={() => togglePlayerDetails(bet)}>
                                        {filters?.agentID && (
                                            <td className='info-item none '>
                                                <Link to={`/user/${bet?.player?.parent}`}>{bet?.player?.parent}</Link>
                                            </td>
                                        )}
                                        <td className='info-item none'>
                                            <Link
                                                to={`/user/${bet?.player?.userName}`}
                                                state={playerNavState(bet?.player)}
                                            >
                                                {bet?.player?.userName}
                                            </Link>
                                        </td>
                                        {filters?.password && (
                                            <td className='none '>
                                                <span>{bet?.player?.pin}</span>
                                            </td>
                                        )}
                                        {filters?.timeScheduled && (
                                            <td className='none team-color-pending'>
                                                {formatTimestamp(bet.gameDate ?? Timestamp.now())}
                                            </td>
                                        )}
                                        {filters?.timeAccepted && (
                                            <td className='none team-color-pending'>
                                                {formatTimestamp(bet.betDate ?? Timestamp.now())}
                                            </td>
                                        )}
                                        <td className='none text-left-important'>
                                            <span>
                                                {(bet.betType === 'Parlay' || bet.betType === 'Teaser') ? (
                                                    <>
                                                        <div className='description-text'>{bet.description}</div>
                                                        {!expandedPlayers.has(bet.ticket) && (
                                                            <>
                                                                <div className='info-descriptions'>
                                                                    {bet.selections?.map((selection: any, index: any) => (
                                                                        <div key={index} style={{ margin: "6px 0px" }}>
                                                                            <BetLogo bet={selection} className="sport-logos-pending" alt="logo" />
                                                                            <span className="fw-bold inter team-color-pending">
                                                                                {getBetPrimaryName(selection)}
                                                                            </span>
                                                                            <span className='bet-format'>
                                                                                {bet.marketName === 'Moneyline' ? (
                                                                                    `ML ${formatWithSign(selection.odd?.price ?? 0, undefined, "price")}`

                                                                                ) : bet.betType === 'Teaser' ? (
                                                                                    selection.odd?.points != null
                                                                                        ? formatWithSign(
                                                                                            selection.odd.points,
                                                                                            selection.odd?.selection_line,
                                                                                            "points"
                                                                                        )
                                                                                        : ''

                                                                                ) : (
                                                                                    <>
                                                                                        {selection.odd?.points != null
                                                                                            ? `${formatWithSign(
                                                                                                selection.odd.points,
                                                                                                selection.odd?.selection_line,
                                                                                                "points"
                                                                                            )} `
                                                                                            : ''}

                                                                                        {selection.odd?.price != null
                                                                                            ? formatWithSign(selection.odd.price, undefined, "price")
                                                                                            : ''}
                                                                                    </>
                                                                                )}
                                                                                &nbsp;
                                                                                {selection.grader?.status === "Completed" && selection.grader?.result && (
                                                                                    <span
                                                                                        style={{
                                                                                            color: selection.grader.result === "Won" ? "green" : "red",
                                                                                            fontWeight: "bold",
                                                                                        }}>
                                                                                        {selection.grader.result === "Won" ? "W" : "L"}
                                                                                    </span>
                                                                                )}
                                                                                {getPendingMarketSubLabel(selection) && (
                                                                                    <span className='name-pending-props'>{getPendingMarketSubLabel(selection)}</span>
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </>
                                                        )}
                                                    </>
                                                ) : (bet.betType === 'Contest' || isPropsBet(bet) || Boolean(getPendingMarketSubLabel(bet))) ? (
                                                    <div>
                                                            <BetLogo bet={bet} className="sport-logos-pending" alt="logo" />

                                                        <span className="fw-bold inter team-color-pending">
                                                            {getBetPrimaryName(bet)}
                                                        </span>
                                                        <span>
                                                            {liveLabel && ` (${liveLabel})`}
                                                            <span className='bet-format'>
                                                                {bet.marketName === 'Moneyline'
                                                                    ? `ML ${formatWithSign(bet.odd?.price)}`
                                                                    : `${bet.odd?.points != null
                                                                        ? formatWithSign(
                                                                            bet.odd?.points,
                                                                            bet.odd?.selection_line,
                                                                            "points"
                                                                        ) + ' '
                                                                        : ''
                                                                    }${formatWithSign(bet.odd?.price)}`
                                                                }
                                                                {isFreePlayBet(bet) && (
                                                                    <span className='bet-free'>{bet.freeBet}</span>
                                                                )}
                                                            </span>
                                                        </span>
                                                        {getPendingMarketSubLabel(bet) && (
                                                            <div>
                                                                <span className='name-pending-props'>{getPendingMarketSubLabel(bet)}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div>
                                                            <BetLogo bet={bet} className="sport-logos-pending" alt="logo" />

                                                        <span className="fw-bold team-color-pending">
                                                            {getBetPrimaryName(bet)}
                                                            {bet.gameType && ` (${bet.gameType.charAt(0).toUpperCase()}${bet.gameType.slice(1)})`}
                                                        </span>
                                                        <span>
                                                            <span className='bet-format'>
                                                                {bet.marketName === 'Moneyline'
                                                                    ? `ML ${formatWithSign(bet.odd?.price)}`
                                                                    : `${bet.odd?.points != null
                                                                        ? formatWithSign(
                                                                            bet.odd?.points,
                                                                            bet.odd?.selection_line,
                                                                            "points"
                                                                        ) + ' '
                                                                        : ''
                                                                    }${formatWithSign(bet.odd?.price)}`
                                                                }
                                                                &nbsp;

                                                                {isFreePlayBet(bet) && (
                                                                    <span className='bet-free'> &nbsp;{bet.freeBet}</span>
                                                                )}
                                                            </span>
                                                        </span>
                                                    </div>
                                                )}
                                            </span>
                                        </td>

                                        <td className='none'>
                                            <span style={{ color: "red", fontWeight: "bold" }}>$   {formatNumbers(bet.bet)}</span>
                                        </td>
                                        <td className='none'>
                                            <span className='fw-bold' style={{ color: "black", }} >${formatNumbers(bet.reward)}</span>
                                        </td>
                                        <td className='none'>
                                            {currentUser.status !== "Read-Only" &&
                                                currentUser.status !== "Disabled" && (
                                                    <IoCloseSharp
                                                        className="close-icon-pending inter"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#deletBet"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setSelectedBet?.(bet);
                                                        }}
                                                    />
                                                )}
                                        </td>

                                        <td className="mobile-only">
                                            <div className="mobile-bet-header">
                                                <div className="user-info">
                                                    <Link
                                                        to={`/user/${bet.player?.userName}`}
                                                        state={playerNavState(bet.player)}
                                                        className="user-name-link"
                                                    >
                                                        {bet.player?.userName}
                                                    </Link>
                                                    <span className='pin-pending'> {bet.player?.pin}</span>

                                                </div>
                                                <span className="reward-amount inter-font">
                                                    ${formatNumbers(bet.bet)}
                                                </span>
                                            </div>
                                            <div className={`mobile-row-container ${expandedPlayers.has(bet.ticket) ? "expanded" : ""}`}>
                                                <div className='left-content selection-description spacig-margin '>
                                                    {bet.betType === 'Parlay' ? (
                                                        <>
                                                            <div className='description-text'>{bet.description}</div>
                                                            {!expandedPlayers.has(bet.ticket) && (
                                                                <div className='info-descriptions'>
                                                                    {bet.selections?.map((selection: any, index: any) => (
                                                                        <div key={index} className='no-spacig-margin'>
                                                                            <BetLogo bet={selection} className="sport-logos-pending" alt="logo" />

                                                                            <span className="fw-bold team-color-pending">
                                                                                {getBetPrimaryName(selection)}
                                                                            </span>
                                                                            <span className="team-size">
                                                                                <span className="bet-format">
                                                                                    {
                                                                                        selection.odd?.market?.toLowerCase()?.includes("moneyline") || selection.odd?.points == null
                                                                                            ? `ML ${formatWithSign(selection.odd?.price)}`
                                                                                            : `${selection.odd?.points != null
                                                                                                ? formatWithSign(
                                                                                                    selection.odd.points,
                                                                                                    selection.odd?.selection_line,
                                                                                                    "points"
                                                                                                ) + " "
                                                                                                : ""
                                                                                            }${selection.odd?.price != null ? formatWithSign(selection.odd.price) : ""}`
                                                                                    }
                                                                                    &nbsp;
                                                                                    {selection.grader?.status === "Completed" && selection.grader?.result && (
                                                                                        <span
                                                                                            style={{
                                                                                                color: selection.grader.result === "Won" ? "green" : "red",
                                                                                                fontWeight: "bold",
                                                                                            }}>
                                                                                            {selection.grader.result === "Won" ? "W" : "L"}
                                                                                        </span>
                                                                                    )}
                                                                                </span>

                                                                            </span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : bet.betType === 'Teaser' ? (
                                                        <>
                                                            <div className='description-text teaser-text'>
                                                                {bet.description} (Teaser)
                                                            </div>
                                                            {!expandedPlayers.has(bet.ticket) && (
                                                                <div className='info-descriptions'>
                                                                    {bet.selections?.map((selection: any, index: any) => (
                                                                        <div key={index} className='no-spacig-margin'>
                                                                            <BetLogo bet={selection} className="sport-logos-pending" alt="logo" />

                                                                            <span className="fw-bold team-color-pending">
                                                                                {getBetPrimaryName(selection)}
                                                                            </span>
                                                                            <span className="team-size">
                                                                                <span className="bet-format">
                                                                                    {selection.marketName?.toLowerCase().includes("moneyline") ? (
                                                                                        <>ML {formatNumber(selection.odd?.price, selection.odd?.selection_line)}</>
                                                                                    ) : selection.odd?.selection_line?.toLowerCase() === "over" ||
                                                                                        selection.odd?.selection_line?.toLowerCase() === "under" ? (
                                                                                        <>
                                                                                            {selection.odd?.points != null && (
                                                                                                <>{formatNumber(selection.odd.points, selection.odd.selection_line, "points")} </>
                                                                                            )}

                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            {selection.odd?.points != null && (
                                                                                                <>{formatNumber(selection.odd.points)} </>
                                                                                            )}

                                                                                        </>
                                                                                    )}
                                                                                </span>
                                                                                {selection.grader?.status === "Completed" && selection.grader?.result && (
                                                                                    <span
                                                                                        style={{
                                                                                            color: selection.grader.result === "Won" ? "green" : "red",
                                                                                            fontWeight: "bold",
                                                                                        }}>
                                                                                        {selection.grader.result === "Won" ? "W" : "L"}
                                                                                    </span>
                                                                                )}
                                                                                {getPendingMarketSubLabel(selection) && (
                                                                                    <span className='name-pending-props'>{getPendingMarketSubLabel(selection)}</span>
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : bet.betType === 'Contest' || isPropsBet(bet) || Boolean(getPendingMarketSubLabel(bet)) ? (
                                                        <div className='no-spacig-margin'>
                                                            <BetLogo bet={bet} className="sport-logos-pending" alt="logo" />
                                                            <span className="fw-bold letters-selected ">
                                                                <span className='team-color-pending'>{getBetPrimaryName(bet)}</span>
                                                                {liveLabel && ` (${liveLabel})`}
                                                                {bet.odd && (bet.odd.points != null || bet.odd.price != null) && (
                                                                    <span className="bet-format">

                                                                        {bet.odd.points != null
                                                                            ? formatNumber(bet.odd.points, bet.odd.selection_line, "points")
                                                                            : ""
                                                                        }{" "}
                                                                        {bet.odd.price != null
                                                                            ? formatNumber(bet.odd.price, bet.odd.selection_line, "price")
                                                                            : ""
                                                                        }
                                                                    </span>
                                                                )}

                                                                {isFreePlayBet(bet) && (
                                                                    <span className="bet-free">
                                                                        {bet.freeBet}
                                                                    </span>
                                                                )}

                                                            </span>
                                                            {getPendingMarketSubLabel(bet) && (
                                                                <div>
                                                                    <span className='name-pending-props'>{getPendingMarketSubLabel(bet)}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <div className='no-spacig-margin'>
                                                            <BetLogo bet={bet} className="sport-logos-pending" alt="logo" />

                                                            <span className="fw-bold team-color-pending">
                                                                {getBetPrimaryName(bet)}
                                                                {bet.gameType && ` (${bet.gameType.charAt(0).toUpperCase()}${bet.gameType.slice(1)})`}
                                                            </span>
                                                            <span className="bet-format">
                                                                {bet.marketName?.toLowerCase().includes("moneyline") || bet.odd?.points == null
                                                                    ? `ML ${formatWithSign(bet.odd?.price)}`
                                                                    : `${bet.odd?.points != null
                                                                        ? formatWithSign(
                                                                            bet.odd.points,
                                                                            bet.odd?.selection_line,
                                                                            "points"
                                                                        ) + " "
                                                                        : ""
                                                                    }${bet.odd?.price != null ? formatWithSign(bet.odd.price) : ""}`
                                                                }
                                                            </span>
                                                            &nbsp;

                                                            {isFreePlayBet(bet) && (
                                                                <span className='bet-free'>{bet.freeBet}</span>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>

                                            </div>

                                        </td>
                                    </tr>

                                    {expandedPlayers.has(bet.ticket) && (
                                        <BetDetailsBox bet={bet} onBetSelected={setSelectedBet} currentUser={currentUser} />
                                    )}

                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            )}


        </>
    )
}

export default BodyPending;